"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extractTargetUnit = _interopRequireDefault(require("./extractTargetUnit"));

var _constants = require("./constants");

var _round = require("./round");

var formatDistanceWithMeasurementSystem = function formatDistanceWithMeasurementSystem(_ref) {
  var distance = _ref.distance,
      _ref$measurementSyste = _ref.measurementSystem,
      measurementSystem = _ref$measurementSyste === void 0 ? 'metric' : _ref$measurementSyste,
      _ref$unit = _ref.unit,
      unit = _ref$unit === void 0 ? 'distance' : _ref$unit,
      _ref$sport = _ref.sport,
      sport = _ref$sport === void 0 ? '' : _ref$sport,
      _ref$precision = _ref.precision,
      precision = _ref$precision === void 0 ? 0 : _ref$precision;
  var targetUnit = (0, _extractTargetUnit["default"])({
    measurementSystem: measurementSystem,
    unit: unit,
    sport: sport
  });

  switch (targetUnit) {
    case 'miles':
      return parseFloat((distance / 1000 * 0.621371).toFixed(_constants.decimalNumber));

    case 'yards':
      return parseFloat((distance * 1.094).toFixed(_constants.decimalNumber));

    case 'feet':
      return parseFloat((distance * 3.281).toFixed(_constants.decimalNumber));

    case 'meters':
      return distance;

    default:
      return (0, _round.round)(distance / 1000, precision);
  }
};

var _default = formatDistanceWithMeasurementSystem;
exports["default"] = _default;
//# sourceMappingURL=formatDistanceWithMeasurementSystem.js.map